export const doriisFeatureKey = 'doriisReports.basic' as const;

export const doriisOfficialSystemValues = ['DORIIS_CA'] as const;
export type DoriisOfficialSystem = (typeof doriisOfficialSystemValues)[number];

export const doriisReportKindValues = ['REGULAR', 'COVER', 'UNKNOWN'] as const;
export type DoriisReportKind = (typeof doriisReportKindValues)[number];

export const doriisSnapshotTypeValues = [
  'FLAT_EXPORT_SUMMARY',
  'SHIPPER_VIEW',
  'RECEIVER_VIEW',
  'COVER_VIEW',
  'MANUAL_STUB',
] as const;
export type DoriisSnapshotType = (typeof doriisSnapshotTypeValues)[number];

export const doriisSourceKindValues = [
  'FLAT_EXPORT',
  'MANUAL_ENTRY',
  'DORIIS_DETAIL_PRINTABLE',
  'DORIIS_DETAIL_SCREEN',
  'SYSTEM_MIGRATION_OR_BRIDGE',
] as const;
export type DoriisSourceKind = (typeof doriisSourceKindValues)[number];

export const doriisReportCompletenessStatusValues = [
  'RAW_ONLY',
  'STUB',
  'PARTIAL',
  'COMPLETE',
] as const;
export type DoriisReportCompletenessStatus = (typeof doriisReportCompletenessStatusValues)[number];

export const doriisReportConflictStatusValues = ['NONE', 'CONFLICT_REVIEW'] as const;
export type DoriisReportConflictStatus = (typeof doriisReportConflictStatusValues)[number];

export const doriisImportParseStatusValues = ['PARSED', 'PARTIAL', 'FAILED'] as const;
export type DoriisImportParseStatus = (typeof doriisImportParseStatusValues)[number];

export const doriisRawImportRowStatusValues = [
  'IMPORTED',
  'DUPLICATE_EXACT',
  'CONFLICT_REVIEW',
  'MISSING_REPORT_NUMBER',
] as const;
export type DoriisRawImportRowStatus = (typeof doriisRawImportRowStatusValues)[number];

export const doriisReportAttachmentStatusValues = ['ACTIVE', 'CORRECTED'] as const;
export type DoriisReportAttachmentStatus = (typeof doriisReportAttachmentStatusValues)[number];

export const doriisReportLinkRoleValues = [
  'SHIPPER_SIDE',
  'RECEIVER_SIDE',
  'COVER_PARENT',
  'COVER_ATTACHMENT',
] as const;
export type DoriisReportLinkRole = (typeof doriisReportLinkRoleValues)[number];

export const doriisOperationalDocumentTypeValues = [
  'Shipment',
  'InboundReceipt',
  'CoverShipment',
] as const;
export type DoriisOperationalDocumentType = (typeof doriisOperationalDocumentTypeValues)[number];

export const doriisReportLinkStatusValues = ['ACTIVE', 'UNLINKED', 'CORRECTED'] as const;
export type DoriisReportLinkStatus = (typeof doriisReportLinkStatusValues)[number];

export const doriisReportLinkedFilterValues = ['ACTIVE', 'NONE'] as const;
export type DoriisReportLinkedFilter = (typeof doriisReportLinkedFilterValues)[number];

export interface DoriisFlatImportRowInput {
  rowNumber?: number | null;
  values: Record<string, unknown>;
}

export interface DoriisOfficialFieldsDto {
  shippingReportNumber?: string | null;
  materialType?: string | null;
  shipperDoriisId?: string | null;
  shipperName?: string | null;
  receiverDoriisId?: string | null;
  receiverName?: string | null;
  reportFromDate?: string | null;
  reportThroughDate?: string | null;
  shippedRedemptionWeightLb?: number | null;
  shippedTotalRefundValueCents?: number | null;
  receivedDate?: string | null;
  weightTicketNumber?: string | null;
  receivedWeightLb?: number | null;
  paymentWeightLb?: number | null;
  processingPaymentCents?: number | null;
  refundValueCents?: number | null;
  adminFeeCents?: number | null;
  totalPaymentCents?: number | null;
  fsn?: string | null;
  attachedToFsn?: string | null;
  coverOwnBuybackWeightLb?: number | null;
  coverOwnBuybackValueCents?: number | null;
  coverOwnRlWeightLb?: number | null;
  coverOwnRlValueCents?: number | null;
  coverOfficialTotalReceivedWeightLb?: number | null;
  coverOfficialTotalPaymentWeightLb?: number | null;
  coverOfficialTotalRedemptionWeightLb?: number | null;
  coverOfficialTotalPaymentValueCents?: number | null;
}

export interface DoriisMatchingSignalsDto {
  shippingReportNumberKey?: string | null;
  materialType?: string | null;
  shipperDoriisId?: string | null;
  receiverDoriisId?: string | null;
  reportFromDate?: string | null;
  reportThroughDate?: string | null;
  receivedDate?: string | null;
  weightTicketNumber?: string | null;
  shippedRedemptionWeightLb?: number | null;
  receivedWeightLb?: number | null;
  paymentWeightLb?: number | null;
  refundValueCents?: number | null;
  totalPaymentCents?: number | null;
}

export interface DoriisShippingReportDto {
  id: string;
  companyId: string;
  officialSystem: DoriisOfficialSystem;
  shippingReportNumber: string | null;
  shippingReportNumberKey: string | null;
  reportKind: DoriisReportKind;
  shipperDoriisId: string | null;
  shipperName: string | null;
  receiverDoriisId: string | null;
  receiverName: string | null;
  shipperRcScopeType: string | null;
  shipperRcScopeId: string | null;
  receiverRcScopeType: string | null;
  receiverRcScopeId: string | null;
  materialType: string | null;
  reportFromDate: string | null;
  reportThroughDate: string | null;
  shippedRedemptionWeightLb: number | null;
  shippedTotalRefundValueCents: number | null;
  receivedDate: string | null;
  weightTicketNumber: string | null;
  receivedWeightLb: number | null;
  paymentWeightLb: number | null;
  processingPaymentCents: number | null;
  refundValueCents: number | null;
  adminFeeCents: number | null;
  totalPaymentCents: number | null;
  completenessStatus: DoriisReportCompletenessStatus;
  conflictStatus: DoriisReportConflictStatus;
  latestEvidenceAt: string | null;
  latestFlatExportEvidenceAt: string | null;
  latestDetailEvidenceAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface DoriisImportBatchDto {
  id: string;
  companyId: string;
  sourceKind: DoriisSourceKind;
  sourceLabel: string | null;
  fileName: string | null;
  importedByUserId: string | null;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  importedAt: string;
  totalRowCount: number;
  importedRowCount: number;
  missingReportNumberCount: number;
  duplicateRowCount: number;
  conflictRowCount: number;
  parseStatus: DoriisImportParseStatus;
  createdAt: string;
}

export interface DoriisRawImportRowDto {
  id: string;
  companyId: string;
  batchId: string;
  reportId: string | null;
  evidenceSnapshotId: string | null;
  originalRowNumber: number;
  normalizedRowHash: string;
  shippingReportNumber: string | null;
  shippingReportNumberKey: string | null;
  parsedOfficialFields: DoriisOfficialFieldsDto;
  commercialFields: Record<string, unknown> | null;
  rawRow: Record<string, unknown>;
  rowStatus: DoriisRawImportRowStatus;
  conflictFields: string[];
  createdAt: string;
}

export interface DoriisReportEvidenceSnapshotDto {
  id: string;
  companyId: string;
  reportId: string;
  snapshotType: DoriisSnapshotType;
  sourceKind: DoriisSourceKind;
  parsedOfficialFields: DoriisOfficialFieldsDto;
  rawEvidence: Record<string, unknown>;
  importBatchId: string | null;
  rawImportRowId: string | null;
  actorUserId: string | null;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  capturedAt: string;
  createdAt: string;
}

export interface DoriisReportAttachmentDto {
  id: string;
  companyId: string;
  coverReportId: string;
  childReportNumber: string | null;
  childReportNumberKey: string | null;
  childReportId: string | null;
  sourceSnapshotId: string | null;
  attachmentValues: Record<string, unknown>;
  status: DoriisReportAttachmentStatus;
  createdAt: string;
  updatedAt: string;
}

export interface DoriisReportLinkDto {
  id: string;
  companyId: string;
  reportId: string;
  coverAttachmentId: string | null;
  role: DoriisReportLinkRole;
  documentType: DoriisOperationalDocumentType;
  documentId: string;
  status: DoriisReportLinkStatus;
  reason: string | null;
  linkedByUserId: string | null;
  unlinkedByUserId: string | null;
  storeId: string | null;
  locationId: string | null;
  stationId: string | null;
  linkedAt: string;
  unlinkedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface DoriisReportDetailDto {
  report: DoriisShippingReportDto;
  evidenceSnapshots: DoriisReportEvidenceSnapshotDto[];
  attachments: DoriisReportAttachmentDto[];
  links: DoriisReportLinkDto[];
}

export interface ImportFlatDoriisRowsRequest {
  companyId: string;
  sourceLabel?: string | null;
  fileName?: string | null;
  importedAt?: string | null;
  rows: DoriisFlatImportRowInput[];
}

export interface ImportFlatDoriisRowsResponse {
  batch: DoriisImportBatchDto;
  rows: DoriisRawImportRowDto[];
  reports: DoriisShippingReportDto[];
}

export interface CreateManualDoriisReportStubRequest {
  companyId: string;
  shippingReportNumber: string;
  reportKind?: DoriisReportKind;
  rawEvidence?: Record<string, unknown> | null;
}

export interface CreateManualDoriisReportStubResponse {
  report: DoriisShippingReportDto;
  evidenceSnapshot: DoriisReportEvidenceSnapshotDto;
}

export interface AddDoriisReportEvidenceSnapshotRequest {
  companyId: string;
  reportId: string;
  snapshotType: DoriisSnapshotType;
  sourceKind: DoriisSourceKind;
  parsedOfficialFields?: DoriisOfficialFieldsDto;
  rawEvidence?: Record<string, unknown> | null;
  capturedAt?: string | null;
}

export interface AddDoriisReportEvidenceSnapshotResponse {
  report: DoriisShippingReportDto;
  evidenceSnapshot: DoriisReportEvidenceSnapshotDto;
}

export interface DoriisCoverAttachmentRowInput {
  childReportNumber?: string | null;
  shipperDoriisId?: string | null;
  shipperName?: string | null;
  receiverDoriisId?: string | null;
  receiverName?: string | null;
  reportFromDate?: string | null;
  reportThroughDate?: string | null;
  receivedDate?: string | null;
  receivedWeightLb?: number | null;
  paymentWeightLb?: number | null;
  totalRedemptionWeightLb?: number | null;
  totalRefundPaymentValueCents?: number | null;
  weightTicketNumber?: string | null;
  rawEvidence?: Record<string, unknown> | null;
}

export interface AddDoriisCoverReportEvidenceRequest {
  companyId: string;
  reportId: string;
  sourceKind: Extract<
    DoriisSourceKind,
    'MANUAL_ENTRY' | 'DORIIS_DETAIL_PRINTABLE' | 'DORIIS_DETAIL_SCREEN'
  >;
  parsedOfficialFields?: DoriisOfficialFieldsDto;
  attachmentRows?: DoriisCoverAttachmentRowInput[];
  rawEvidence?: Record<string, unknown> | null;
  capturedAt?: string | null;
}

export interface AddDoriisCoverReportEvidenceResponse {
  report: DoriisShippingReportDto;
  evidenceSnapshot: DoriisReportEvidenceSnapshotDto;
  attachments: DoriisReportAttachmentDto[];
}

export interface ListDoriisReportsRequest {
  companyId: string;
  query?: string | null;
  reportKind?: DoriisReportKind | null;
  conflictStatus?: DoriisReportConflictStatus | null;
  completenessStatus?: DoriisReportCompletenessStatus | null;
  linkedStatus?: DoriisReportLinkedFilter | null;
  limit?: number | null;
}

export interface ListDoriisReportsResponse {
  items: DoriisShippingReportDto[];
}

export interface GetDoriisReportRequest {
  companyId: string;
  reportId: string;
}

export interface GetDoriisReportResponse {
  detail: DoriisReportDetailDto;
}

export interface ListDoriisRawImportRowsRequest {
  companyId: string;
  query?: string | null;
  rowStatus?: DoriisRawImportRowStatus | null;
  rowStatuses?: DoriisRawImportRowStatus[] | null;
  reportId?: string | null;
  limit?: number | null;
}

export interface ListDoriisRawImportRowsResponse {
  items: DoriisRawImportRowDto[];
}

export interface GetActiveDoriisReportLinkRequest {
  companyId: string;
  documentType: DoriisOperationalDocumentType;
  documentId: string;
  role: DoriisReportLinkRole;
}

export interface GetActiveDoriisReportLinkResponse {
  link: DoriisReportLinkDto | null;
  detail: DoriisReportDetailDto | null;
}

export interface GetDoriisSuggestedMatchesRequest {
  companyId: string;
  documentType: DoriisOperationalDocumentType;
  documentId: string;
  role?: DoriisReportLinkRole | null;
  shippingReportNumber?: string | null;
  materialType?: string | null;
  shipperDoriisId?: string | null;
  receiverDoriisId?: string | null;
  receivedWeightLb?: number | null;
  paymentWeightLb?: number | null;
}

export interface DoriisSuggestedMatchDto {
  report: DoriisShippingReportDto;
  score: number;
  reasons: string[];
}

export interface GetDoriisSuggestedMatchesResponse {
  items: DoriisSuggestedMatchDto[];
}

export interface GetDoriisReportDocumentSuggestionsRequest {
  companyId: string;
  reportId: string;
  limit?: number | null;
}

export interface DoriisReportDocumentSuggestionDto {
  documentType: Extract<DoriisOperationalDocumentType, 'Shipment' | 'InboundReceipt'>;
  documentId: string;
  role: Extract<DoriisReportLinkRole, 'SHIPPER_SIDE' | 'RECEIVER_SIDE'>;
  score: number;
  reasons: string[];
  label: string;
  materialLabel: string | null;
  dateLabel: string | null;
  weightLabel: string | null;
  counterpartyLabel: string | null;
  alreadyLinked: boolean;
}

export interface GetDoriisReportDocumentSuggestionsResponse {
  items: DoriisReportDocumentSuggestionDto[];
}

export interface GetDoriisCoverAttachmentInboundSuggestionsRequest {
  companyId: string;
  coverAttachmentId: string;
  limit?: number | null;
}

export interface DoriisCoverAttachmentInboundSuggestionDto {
  documentType: 'InboundReceipt';
  documentId: string;
  role: 'COVER_ATTACHMENT';
  coverAttachmentId: string;
  score: number;
  reasons: string[];
  label: string;
  materialLabel: string | null;
  dateLabel: string | null;
  weightLabel: string | null;
  counterpartyLabel: string | null;
  alreadyLinked: boolean;
}

export interface GetDoriisCoverAttachmentInboundSuggestionsResponse {
  items: DoriisCoverAttachmentInboundSuggestionDto[];
}

export interface LinkDoriisReportRequest {
  companyId: string;
  reportId: string;
  role: DoriisReportLinkRole;
  documentType: DoriisOperationalDocumentType;
  documentId: string;
  coverAttachmentId?: string | null;
  reason?: string | null;
}

export interface LinkDoriisReportResponse {
  link: DoriisReportLinkDto;
}

export interface UnlinkDoriisReportRequest {
  companyId: string;
  linkId: string;
  reason: string;
}

export interface UnlinkDoriisReportResponse {
  link: DoriisReportLinkDto;
}
